const meetOurGrowers = () => {
  const width = $(window).width();
  function initSlick() {
    const oDOMContainer = $(
      '.meet-our-growers-section .grower-slider-container',
    );
    const oDOMThumbnail = $(
      '.meet-our-growers-section .slides-container--thumbnail',
    );

    let thumbnailShowCount = 4;

    if (oDOMContainer.children().length > 3) {
      thumbnailShowCount = 3;
    }

    if (oDOMContainer) {
      const settings_container = {
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: false,
        infinite: false,
        touchThreshold: 100,
        asNavFor: '.slides-container--thumbnail',
      };
      let thumbnailGap = 18;
      if (width < 1024) {
        thumbnailGap = 15;
      }
      const settings_thumbnail = {
        dots: true,
        arrows: false,
        centerMode: false,
        focusOnSelect: true,
        slidesToShow: thumbnailShowCount,
        slidesToScroll: 1,
        infinite: false,
        variableWidth: true,
        touchThreshold: thumbnailGap,
        asNavFor: '.grower-slider-container',
      };

      oDOMContainer.not('.slick-initialized').slick(settings_container);
      oDOMThumbnail.not('.slick-initialized').slick(settings_thumbnail);
    }
  }

  initSlick();

  $(window)
    .on('resize', function () {
      initSlick();
      // Invoke the resize event immediately
    })
    .resize();

  // Trigger slick in homepage hero banner when customizing theme
  $(window).on('shopify-custom-meet-our-growers-event', function () {
    initSlick();
  });
};

export default meetOurGrowers;
